
// Constant Data for Scraper Product

export const CURATION_STATUS = {
  PENDING               : 'pending',
  AUTO_CURATION_FAILED  : 'auto_curation_failed',
  CURATED_AUTOMATICALLY : 'curated_automatically',
  CURATED_MANUALLY      : 'curated_manually',
  REJECTED              : 'rejected'
}

export const AVAILABLE_ON_SOURCE = {
  YES : 'yes',
  NO  : 'no'
}

export const AVAILABLE_ON_SOURCE_OPTIONS = [
  {
    'label' : 'Choose one',
    'value' : ''
  },
  {
    label : 'Yes',
    value : AVAILABLE_ON_SOURCE.YES
  },
  {
    label : 'No',
    value : AVAILABLE_ON_SOURCE.NO
  }
]

export const ORDER_STATUS = {
  UNORDERED           : 'unordered',
  ORDERED             : 'ordered',
  PURCHASED_FROM_SITE : 'purchased_from_site',
  ARRIVED             : 'arrived'
}

export const GENDER = {
  FEMALE : 'female',
  MALE   : 'male'
}

export const BRAND_CLASSIFICATIONS = {
  ASPIRATIONAL_LUXURY : 'Aspirational Luxury',
  HIGH_END_LUXURY     : 'High End Luxury',
  BRANDED             : 'Branded',
  LUXURY              : 'Luxury',
  MALE                : 'Male',
  FEMALE              : 'Female'
}

export const PER_PAGE = {
  5  : '5',
  10 : '10',
  25 : '25'
}

export const CURATED_CURATION_STATUS = {
  CURATED               : 'all_curated',
  CURATED_AUTOMATICALLY : 'curated_automatically',
  CURATED_MANUALLY      : 'curated_manually'
}

export const CURATED_CURATION_STATUS_OPTIONS = [
  {
    label : 'All Curated',
    value : CURATED_CURATION_STATUS.CURATED
  },
  {
    label : 'Curated Automatically',
    value : CURATED_CURATION_STATUS.CURATED_AUTOMATICALLY
  },
  {
    label : 'Curated Manually',
    value : CURATED_CURATION_STATUS.CURATED_MANUALLY
  }
]

export const PRODUCT_STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}
